import { addHoursToDate } from './utils'

const ATTRIBUTION_KEY = 'LEAD_ATTRIBUTIONS'

const ATTRIBUTION_TAGS = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign']

const setLeadAttributions = () => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  let leadAttributions = []

  ATTRIBUTION_TAGS.forEach((item) => {
    const value = urlParams.get(item)
    if (value) {
      leadAttributions.push({
        sourceName: item,
        sourceValue: value,
      })
    }
  })

  if (leadAttributions.length > 0) {
    const item = JSON.stringify({
      timestamp: Date.now(),
      attributions: leadAttributions,
    })
    window.localStorage.setItem(ATTRIBUTION_KEY, item)
  }
}

const getLeadAttributions = () => {
  const item = window.localStorage.getItem(ATTRIBUTION_KEY)
  const value = JSON.parse(item)

  // Remove storage item after read
  localStorage.removeItem(ATTRIBUTION_KEY)

  // Handle empty values
  if (!value) {
    return null
  }

  // Handle old lead attributions without a timestamp
  if (!value.timestamp) {
    return value
  }

  // Check for expiration
  const timestamp = new Date(value.timestamp)
  const expirationDate = addHoursToDate(timestamp, 24)
  if (Date.now() > expirationDate) {
    return null
  }

  return value.attributions
}

export { setLeadAttributions, getLeadAttributions }
